import { Logtail } from '@logtail/browser';

const logtail = new Logtail(process.env.REACT_APP_LOGGER_TOKEN);

export const logEvent = (message: string, context: Record<string, unknown> = {}) => {
  logtail.info(message, context);
};
